export default __webpack_public_path__ + "static/mortgage-color-cd46c894aedd561e5a0ad688cd2d9d48.svg";